var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMastercard(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 48,
    height: 32,
    rx: 4,
    fill: "#121318"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.65 11.2h38.71v25.6H4.65z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F26122",
    d: "M18.9 15.66h10.21v16.68H18.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24a10.58 10.58 0 014-8.34 10.61 10.61 0 100 16.68A10.58 10.58 0 0120 24z",
    fill: "#EA1D25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.14 30.23v.34h-.06v-.34h-.14v-.07h.35v.07h-.15zm.68-.07v.41h-.07v-.31l-.11.27h-.08l-.12-.27v.31h-.07v-.41h.1l.13.29.12-.29h.1z",
    fill: "#F69E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.16 24A10.61 10.61 0 0124 32.34c4.6-3.622 5.397-10.286 1.78-14.89A10.4 10.4 0 0024 15.66 10.61 10.61 0 0141.16 24z",
    fill: "#F69E1E"
  })));
}

export default SvgMastercard;